__turbopack_context__.v({
  "captionTitle": "HeroCatSection-module__rDEnrG__captionTitle",
  "description": "HeroCatSection-module__rDEnrG__description",
  "imgContainer": "HeroCatSection-module__rDEnrG__imgContainer",
  "imgTextContainer": "HeroCatSection-module__rDEnrG__imgTextContainer",
  "imgWrapper": "HeroCatSection-module__rDEnrG__imgWrapper",
  "root": "HeroCatSection-module__rDEnrG__root",
  "textContainer": "HeroCatSection-module__rDEnrG__textContainer",
});
